import { render, staticRenderFns } from "./vsDialogCustom.vue?vue&type=template&id=8ac1eec2"
import script from "./vsDialogCustom.vue?vue&type=script&lang=js"
export * from "./vsDialogCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ac1eec2')) {
      api.createRecord('8ac1eec2', component.options)
    } else {
      api.reload('8ac1eec2', component.options)
    }
    module.hot.accept("./vsDialogCustom.vue?vue&type=template&id=8ac1eec2", function () {
      api.rerender('8ac1eec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsDialogCustom/vsDialogCustom.vue"
export default component.exports